import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { AuthStateFacade } from '@zero/shared/util-global-state';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { GuidedTourNotifications } from '../entities/notifications.model';

@Injectable({ providedIn: 'root' })
export class GuidedTourInfrastructure {
  readonly #http = inject(HttpClient);
  readonly #authStateFacade = inject(AuthStateFacade);
  readonly #endpoint = `${environment.apihost}/api/guidedtour`;

  public getShowNotifications(): Observable<GuidedTourNotifications> {
    return this.#http.get<GuidedTourNotifications>(`${this.#endpoint}/notification/show`, {
      params: {
        customerId: this.#authStateFacade.customerId,
      },
    });
  }

  public putDismissNotification(): Observable<void> {
    return this.#http.put<void>(
      `${this.#endpoint}/notification/dismiss`,
      {},
      {
        params: {
          customerId: this.#authStateFacade.customerId,
        },
      },
    );
  }
}
